import { Chip, Stack } from '@mui/material';

const RoleCustomPaymentTypeAccessSummary = ({ role, size = 'small' }) => {
  if (!role) {
    return null;
  }

  const isEnabled = Boolean(role.custom_payment_type_access_enabled);
  const selectedCount = Number(role.selected_custom_payment_type_count || 0);
  const disabledSelectedCount = Number(
    role.disabled_selected_custom_payment_type_count || 0,
  );

  const primaryChip = !isEnabled
    ? {
        label: 'Custom Types Off',
        color: 'default',
      }
    : selectedCount === 0
    ? {
        label: 'Custom Types None',
        color: 'warning',
      }
    : {
        label: `${selectedCount} Custom Type${selectedCount === 1 ? '' : 's'}`,
        color: 'success',
      };

  return (
    <Stack direction='row' spacing={1} useFlexGap flexWrap='wrap'>
      <Chip size={size} label={primaryChip.label} color={primaryChip.color} />
      {disabledSelectedCount > 0 && (
        <Chip
          size={size}
          label={`${disabledSelectedCount} Disabled`}
          color='warning'
          variant='outlined'
        />
      )}
    </Stack>
  );
};

export default RoleCustomPaymentTypeAccessSummary;
